import { TextureData } from "../../../types/types";
import { ISize } from "../../../controls/scrollpane/ISize";
import { RectSize } from "../../../utils/RectSize";
import { SettingsItem } from "../options/SettingsItem";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { LayoutDataManager } from "../../managers/LayoutDataManager";


/**
 * @alike ResultsHeaderItem
 */
export class StatisticsListItem 
    extends SettingsItem
    implements ISize
{
    public label2: Phaser.GameObjects.Text;

    protected bgTextureData: TextureData;
    protected labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle;

    // separate delimiter line addition
    public imgDelimiterLine: Phaser.GameObjects.Image;
    protected hasDelimiterLine: boolean;
    protected delimiterLineAlpha: number;


    public Init(
        bgTextureData: TextureData = undefined, 
        labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle = undefined,
    ): void
    {
        this.bgTextureData = bgTextureData;
        this.labelTextStyle = labelTextStyle;

        this.size = new RectSize();
        this.delimiterLineAlpha = LayoutDataManager.GetSharedData().general.screen.item.delimiterLine.alpha;
        
        // DEBUG
        // console.log(this.itemSpacing, this.borderPadding);
        this.itemSpacing.Set(40, 0);
        // this.borderPadding.Set(0, 0);
    }

    public Build(): void
    {
        this.bg = this.scene.make.image({x:0, y:0, key:this.bgTextureData.texture, frame:this.bgTextureData.frame});
        this.bg.setOrigin(0);
        this.add(this.bg);
        
        this.imgDelimiterLine = this.scene.make.image({key:LoaderFileKeys.ui, frame:"rect-2x2-white.png"});
        this.imgDelimiterLine.setOrigin(0, 0.5);
        this.imgDelimiterLine.alpha = this.delimiterLineAlpha;
        this.add(this.imgDelimiterLine);

        this.label = this.scene.make.text({style: this.labelTextStyle});
        this.label.setOrigin(0, 0.5);
        this.add(this.label);

        this.label2 = this.scene.make.text({style: this.labelTextStyle});
        this.label2.setOrigin(1, 0.5);
        this.add(this.label2);
    }

    public SetData(
        label: string = undefined,
        label2: string = undefined,
        hasDelimiterLine: boolean,
    ): void 
    {
        if (label != undefined) {
            this.label.text = label;
        }
        if (label2 != undefined) {
            this.label2.text = label2;
        }
        this.hasDelimiterLine = hasDelimiterLine;
        this.imgDelimiterLine.visible = hasDelimiterLine;
    }
    
    /**
     * @alike: OnResize
     * Uses 'maximum allowed width' to compute item's resulting height
     * - Item's width and height depends on height of label textfield
     * - label's height depends on amount of HORIZONTAL space and maximum horizontal space allowed for item
     * 
     * @param width 
     */
    public override SetWidthGetHeight(width: number): number
    {
        // keep label2 without wordWrap and adjust wordWrap of label
        this.label.style.setWordWrapWidth(width - this.label2.displayWidth - this.itemSpacing.width - 2*this.borderPadding.horizontal);

        // NOTE: both fields use same style, so their height is same (until label becomes multiline)
        return this.label.displayHeight + 2*this.borderPadding.vertical;
    }

    public override OnResize(): void
    {
        this.bg.setDisplaySize(this.size.width, this.size.height);

        // delimiter (if item has it -- last item in list does not have it)
        if (this.hasDelimiterLine) {
            // origin 0,1 (bot left)
            this.imgDelimiterLine.y = this.size.height;
            this.imgDelimiterLine.displayWidth = this.size.width;
        }

        // label origin (0, 0.5)
        this.label.setPosition(this.borderPadding.horizontal, this.size.height/2);
        // label origin (1.0, 0.5)
        this.label2.setPosition(this.size.width - this.borderPadding.horizontal, this.size.height/2);
    }
}